export default "<h1>Widget</h1>";